import { render, staticRenderFns } from "./threeDimensional.vue?vue&type=template&id=59c4f98a&scoped=true"
import script from "./threeDimensional.vue?vue&type=script&lang=js"
export * from "./threeDimensional.vue?vue&type=script&lang=js"
import style0 from "./threeDimensional.vue?vue&type=style&index=0&id=59c4f98a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4f98a",
  null
  
)

export default component.exports